import { EventEmitter, inject,Injectable } from '@angular/core';
import { HttpService, Search } from '@docpath/linces-angular-components/common';

import { EndPoints } from '../../../../constants/end-points';
import { Alias } from '../models/alias';

@Injectable({
    providedIn: 'root'
})
export class AliasHttpService {
    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_ALIAS}`;
    private readonly toastPrefix = 'alias-config.alias-row.toast';

    showLoadingChanged: EventEmitter<boolean> = new EventEmitter();

    private readonly httpService = inject(HttpService);

    getAlias(search: Search, suscribe: (result: Alias[], totalSize: number) => void): void {
        const searchBase64 = btoa(JSON.stringify(search));
        this.showLoadingChanged.emit(true);

        this.httpService.get({
            relativeUrl: this.relativeUrl,
            queryParameters: { search: searchBase64 },
            suscribe: response => {
                const responseBody = response.result as unknown as Search,
                    result = responseBody.result as Alias[],
                    totalSize = responseBody.paginator?.totalSize ?? 0;
                this.showLoadingChanged.emit(false);
                suscribe(result, totalSize);
            },
            suscribeOnError: () => {
                this.showLoadingChanged.emit(false);
            }
        });
    }

    getAllAlias(suscribe: (result: Alias[]) => void): void {
        this.httpService.get({
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_ALL}`,
            suscribe: response => {
                const result = response.result?.result as Alias[];
                suscribe(result);
            }
        });
    }

    editAlias(alias: Alias, suscribe: () => void): void {
        this.httpService.put(alias, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.update-success`
        });
    }

    deleteAlias(aliasIds: number[], suscribe: () => void): void {
        this.httpService.delete({
            relativeUrl: `${this.relativeUrl}`,
            queryParameters: { ids: aliasIds },
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.delete-success`
        });
    }


    createAlias(alias: Alias, suscribe: () => void): void {
        this.httpService.post(alias, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.create-success`
        });
    }
}